import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMap = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.7124 20.6643 L5.2449 24.9309 L5.2453 7.8645 L12.7118 3.5971 M12.7124 20.6643 L20.1787 24.9306 M12.7124 20.6643 L12.7118 3.5971 M20.1787 24.9306 L26.5791 20.6644 L26.5784 3.5972 L20.1792 7.8643 M20.1787 24.9306 L20.1792 7.8643 M20.1792 7.8643 L12.7118 3.5971",
				stroke: "white",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 5.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.2453 7.8645 L5.2449 24.9309 L12.7124 20.6643 L20.1787 24.9306 L26.5791 20.6644 L26.5784 3.5972 L20.1792 7.8643 L12.7118 3.5971 Z",
				style: { fill: "var(--sticker-pastel,#D1D7B3)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.7124 20.6643 L5.2449 24.9309 L5.2453 7.8645 L12.7118 3.5971 M12.7124 20.6643 L20.1787 24.9306 M12.7124 20.6643 L12.7118 3.5971 M20.1787 24.9306 L26.5791 20.6644 L26.5784 3.5972 L20.1792 7.8643 M20.1787 24.9306 L20.1792 7.8643 M20.1792 7.8643 L12.7118 3.5971",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				style: { stroke: "var(--sticker-dark,#5F6F27)" }
			})
		]
	});
};
export default SvgMap;
